import React from 'react';
import { useTranslation } from 'react-i18next';

import { CloudUploadOutlined } from '@ant-design/icons';
import { Upload as AntUpload } from 'antd';
import './drag-n-drop-upload.scss';

interface DragNDropUploadProps {
  multiple?: boolean;
  uploadIcon?: React.ReactNode;
  uploadText?: React.ReactNode;
  onRemove: (file) => void;
  onChange: (file) => void;
  fileList: any;
  fileFormat?: string;
}

export const DragNDropUpload: React.FC<DragNDropUploadProps> = ({
  multiple = false,
  uploadIcon,
  uploadText,
  onRemove,
  onChange,
  fileList,
  fileFormat = '.png, .jpg, .jpeg, .pdf',
}) => {
  const { Dragger } = AntUpload;
  const { t } = useTranslation();

  const props = {
    // fileList={featureImage}
    // onChange={onChangeFeature}
    // maxCount={1}
    // onPreview={onPreview}
    // onRemove={imageRemove}
    // maxCount: 1,
    accept: fileFormat,
    onChange: onChange,
    onRemove: onRemove,
    onDrop(e) {},
  };

  return (
    <div className="drag-n-drop-upload">
      <Dragger
        multiple={multiple}
        style={{ height: '50vh', maxHeight: '300px', minHeight: 220 }}
        beforeUpload={() => false}
        fileList={fileList}
        {...props}
      >
        <p className="ant-upload-drag-icon">{uploadIcon ? uploadIcon : <CloudUploadOutlined />}</p>
        {uploadText ? (
          uploadText
        ) : (
          <p className="ant-upload-text p-10">Click or drag file to this area to upload</p>
        )}
      </Dragger>
    </div>
  );
};
